// extracted by mini-css-extract-plugin
export default {"image":"GX-z","loaded":"HX-z"};